import React from 'react';
import NavigationItem from './NavigationItem';
import { useSelector } from 'react-redux';

const Navigation = () => {
  // hamburgerNavigation is the complete link set (the navigation slice
  // excludes links flagged as hamburger-only in back office)
  const contentLinks = useSelector(
    (state) =>
      state.hamburgerNavigation?.contentLinks || state.navigation.contentLinks
  );

  return <NavigationItem links={contentLinks} />;
};

export default Navigation;
